
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/partners",
      function () {
        return require("private-next-pages/about/partners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/partners"])
      });
    }
  